function fixPopUpHeadings () {
  const headingStockAvailability = document.querySelector('.sto-modal-header-contents h2')
  const modal = document.querySelector('#dropahint-modal')
  const modalTitle = modal?.querySelector('h2')
  const modalsubTitle = modal?.querySelector('h4')

  if (headingStockAvailability) changeTag(headingStockAvailability, 'span')
  if (modalTitle) changeTag(modalTitle, 'span')
  if (modalsubTitle) changeTag(modalsubTitle, 'span')
}

function changeTag(element, newTagName) {
  const newElement = document.createElement(newTagName);
  Array.from(element.attributes).forEach(attr => {
    newElement.setAttribute(attr.name, attr.value);
  });
  while (element.firstChild) {
    newElement.appendChild(element.firstChild);
  }
  element.parentNode.replaceChild(newElement, element);
  return newElement;
}

// fixPopUpHeadings();

// swatch slider arrow logic 
console.log("swatch slider arrow logic ");
const radioButtons = document.querySelector('.radio__buttons');
const carouselCell = document.querySelectorAll('.carousel-cell');
function hideArrow() {
  const style = document.createElement('style');
  style.innerHTML = `.radio__buttons .flickity-prev-next-button { display: none; }`;
  const radioButtons = document.querySelector('.radio__buttons');
  radioButtons.appendChild(style);
}    
const cellLength = carouselCell.length;
if (cellLength == 5 && window.innerWidth > 400) {
  hideArrow();
} else if (cellLength == 6 && window.innerWidth > 460 && window.innerWidth < 750) {
  hideArrow();
} else if (cellLength == 7 && window.innerWidth > 540 && window.innerWidth < 750) {
  hideArrow();
} else if (cellLength == 7 && window.innerWidth > 1470) {
  hideArrow();
} else if (cellLength == 8 && window.innerWidth > 610 && window.innerWidth < 750) {
  hideArrow();
} else if (cellLength == 9 && window.innerWidth > 690 && window.innerWidth < 750) {
  hideArrow();
}

// mobile watch button logic 
console.log("mobile watch button logic ");
const productSlides = document.querySelectorAll('.product__slide');
let firstDeferredMediaIndex = null;

productSlides.forEach(function(productSlide, index) {
  const deferredMedia = productSlide.querySelector('.product__media.deferred-media');
  if (deferredMedia && firstDeferredMediaIndex === null) {
    firstDeferredMediaIndex = index;
  }
});
if (firstDeferredMediaIndex !== null && window.innerWidth < 750) {
  const targetNode = document.querySelector('.product__page');
  if (!targetNode) {
    console.error('The target node for MutationObserver is not found');
  }
  const thumbnailObserverConfig = { childList: true, subtree: true };
  const thumbnailObserver = new MutationObserver(function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && document.querySelectorAll('.product__thumb').length > 0) {
        const thumbnails = document.querySelectorAll('.product__thumb');
        const thumbnail = thumbnails[firstDeferredMediaIndex];
        const a_link = thumbnail ? thumbnail.querySelector('.product__thumb__link') : null;
        
        const mobileWatchButtons = document.querySelectorAll('.product__page .mobile_watch_button');
        mobileWatchButtons.forEach(function(button) {
          button.addEventListener('click', function() {
            if (a_link) {
              a_link.click();
            }
          });
        });

        thumbnailObserver.disconnect();
        break;
      }
    }
  });
  thumbnailObserver.observe(targetNode, thumbnailObserverConfig);
}

// USP boxes logic 
console.log("USP boxes logic");
const usps = document.querySelectorAll('.usp');
for (let i = 0; i < usps.length; i++) {
  if (i < 4) {
    usps[i].style.visibility = 'visible';
    if (i % 2 !== 0){
      usps[i].style.marginLeft = '2%';
    } else {
      // Start each pair on a fresh row so a taller tile above can't snag the next float
      usps[i].style.clear = 'left';
    }
  } else {
    usps[i].style.display = 'none';
  }
}

// klaviyo script tracking
console.log("klaviyo script tracking logic");
window.addEventListener('load', function() {
  var _learnq = window._learnq || [];
  function addedToCart() {
    fetch(`${window.location.origin}/cart.js`)
    .then(res => res.clone().json().then(data => {
      var cart = {
        total_price: data.total_price/100,
        $value: data.total_price/100,
        total_discount: data.total_discount,
        original_total_price: data.original_total_price/100,
        items: data.items
      }
      if (item !== 'undefined') {
        cart = Object.assign(cart, item)
      }
      if (klAjax) {
          _learnq.push(['track', 'Added to Cart', cart]);
          klAjax = false;
        }
    }))
  };
  (function (ns, fetch) {
    ns.fetch = function() {
      const response = fetch.apply(this, arguments);
      response.then(res => {
        if (`${window.location.origin}/cart/add.js`
          .includes(res.url) && res.url !== '') {
            addedToCart()
        }
      });
      return response
    }
  }(window, window.fetch));
  var klAjax = true;
  var atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit']");
  for (var i = 0; i < atcButtons.length; i++) {
      atcButtons[i].addEventListener("click", function() {
        if (klAjax) {
          _learnq.push(['track', 'Added to Cart', item]);
          klAjax = false;
        }
      })
  }
});

// Load more image logic 
console.log("Load more image logic");
var container = document.querySelector('#productGallery');
var loadMoreBtn = document.querySelector('#loadMore');
var loadLessBtn = document.querySelector('#viewLess');
if (container && loadMoreBtn && loadLessBtn) {  
  var divsToLoad = 2;
  var divsLoaded = 16;
  loadLessBtn.setAttribute('disabled', 'true');
  loadMoreBtn.addEventListener('click', function () {
    var allSlides = container.querySelectorAll('div.product__slide');
    var totalSlides = allSlides.length;
    var start = divsLoaded + 1;
    var end = divsLoaded + divsToLoad;
    var divs = container.querySelectorAll(
      'div.product__slide:nth-of-type(n + ' + start + '):nth-of-type(-n + ' + end + ')'
    );
    divs.forEach(function (div) {
      div.classList.add('show');
    });
    divsLoaded += divs.length;
    if (divsLoaded >= totalSlides) {
      loadMoreBtn.setAttribute('disabled', 'true');
    }
    if (divsLoaded > 16) {
      loadLessBtn.removeAttribute('disabled');
    }
  });
  loadLessBtn.addEventListener('click', function () {
    var start = divsLoaded - divsToLoad + 1;
    var end = divsLoaded;
    var divs = container.querySelectorAll(
      'div.product__slide:nth-of-type(n + ' + start + '):nth-of-type(-n + ' + end + ')'
    );
    divs.forEach(function (div) {
      div.classList.remove('show');
    });
    divsLoaded -= divs.length;
    if (divsLoaded <= 16) {
      loadLessBtn.setAttribute('disabled', 'true');
    }
    loadMoreBtn.removeAttribute('disabled');
  });
}

// View number svg addition
console.log("view number svg logic");
(function () {
  const targetId = 'effectiveAppsProductVisitorsCounterElement';
  const svgString = `
  <div style="height: 17px; padding-top: 2px;">
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_8668_2268)">
        <path d="M1.37427 7.00004C1.37427 7.00004 3.7076 2.33337 7.79093 2.33337C11.8743 2.33337 14.2076 7.00004 14.2076 7.00004C14.2076 7.00004 11.8743 11.6667 7.79093 11.6667C3.7076 11.6667 1.37427 7.00004 1.37427 7.00004Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.79102 8.75C8.75751 8.75 9.54102 7.9665 9.54102 7C9.54102 6.0335 8.75751 5.25 7.79102 5.25C6.82452 5.25 6.04102 6.0335 6.04102 7C6.04102 7.9665 6.82452 8.75 7.79102 8.75Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_8668_2268">
          <rect width="14" height="14" fill="white" transform="translate(0.791016)"/>
        </clipPath>
      </defs>
    </svg>
  </div>
  `;
  const injectSVG = () => {
    const container = document.getElementById(targetId);
    if (!container) return false;
    const wrapper = container.closest('.add-to-cart-btn-group');
    if (wrapper) {
      wrapper.parentNode.insertBefore(container, wrapper);
    }
    const p = container.querySelector('p');
    if (p && !p.querySelector('svg')) {
      const temp = document.createElement('div');
      temp.innerHTML = svgString.trim();
      const svg = temp.firstChild;
      const span = p.querySelector('span');
      if (span) {
        p.insertBefore(svg, span);
      }
      p.style.display = 'flex';
      p.style.justifyContent = 'center';
      p.style.gap = '2px';
    }
    return true;
  };
  const visitorsCounterObserver = new MutationObserver((mutationsList, obs) => {
    if (injectSVG()) {
      obs.disconnect();
    }
  });
  visitorsCounterObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
  setTimeout(() => {
    visitorsCounterObserver.disconnect();
  }, 5000);
})();


// watch button hide for slides after the videos
console.log("watch button hide for slides after the videos");
function hideMobileWatchButtonsAfterDeferredMedia() {
  const galleryEl = document.querySelector('#productGallery');
  if (!galleryEl) return;
  const flickitySlider = galleryEl.querySelector('.flickity-slider');
  if (!flickitySlider) return;
  const slides = Array.from(flickitySlider.children);
  let deferredMediaSlideNumber = null;
  slides.forEach((slide, index) => {
    if (deferredMediaSlideNumber === null && slide.querySelector('.deferred-media')) {
      deferredMediaSlideNumber = index + 1;
    }
  });
  if (deferredMediaSlideNumber !== null) {
    const watchButtons = document.querySelectorAll('.mobile_watch_button');
    watchButtons.forEach((button, idx) => {
      if (idx + 2 > deferredMediaSlideNumber) {
        button.style.visibility = 'hidden';
      }
    });
  }
}


// video sliding functionality 
console.log("video sliding functionality ");
function setupVideoSwipeControlWithoutInstance() {
  const galleryEl = document.querySelector('#productGallery');
  if (!galleryEl) return;
  function startObserving() {
    const flickityViewport = galleryEl.querySelector('.flickity-viewport');
    const flickitySlider = galleryEl.querySelector('.flickity-slider');
    const flkty = galleryEl?.flickityInstance;
    if (!flickityViewport || !flickitySlider || !flkty) return;
    console.log("removing brand video from mobile");
    const isMobile = () => window.matchMedia('(max-width: 767px)').matches;
    if (flkty && isMobile()) {
      const cells = flkty.getCellElements();
      if (!cells || cells.length === 0) {
        console.log("no cells exist in flickity instance")
      } else {
        const lastIndex = cells.length - 1;
        const lastCellEl = cells[lastIndex];
        const hasDeferred = !!lastCellEl?.querySelector('deferred-media.product__media.deferred-media');
        console.log('brand video detected?', hasDeferred);
        if (hasDeferred) {
          const wasSelectedLast = flkty.selectedIndex === lastIndex;
          flkty.remove(lastCellEl);
          if (wasSelectedLast) {
            const newIndex = Math.max(0, flkty.cells.length - 1);
            flkty.select(newIndex, false, true);
          }
          flkty.resize();
          const thumbsHolder = document.querySelector('.product__thumbs__holder');
          const lastThumb = thumbsHolder?.querySelector('.product__thumb:last-child');
          if (lastThumb) lastThumb.remove();
          console.log("brand video on mobile removed");
        }
      }
      
    }
    const deferredMedias = document.querySelectorAll('.deferred-media');
    if (deferredMedias.length === 0) return;
    deferredMedias.forEach(media => {
      const observer = new MutationObserver(mutationsList => {
        mutationsList.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.tagName === 'VIDEO' && !node.dataset.dragAttached) {
              node.dataset.dragAttached = 'true';
              let startX = 0;
              let startY = 0;
              let moved = false;
              node.addEventListener('touchstart', e => {
                if (e.touches.length !== 1) return;
                startX = e.touches[0].clientX;
                startY = e.touches[0].clientY;
                moved = false;
              }, { passive: true });
              node.addEventListener('touchmove', e => {
                if (e.touches.length !== 1) return;
                const currentX = e.touches[0].clientX;
                const currentY = e.touches[0].clientY;
                const deltaX = currentX - startX;
                const deltaY = currentY - startY;
                if (!moved && Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 30) {
                  moved = true;
                  if (deltaX > 0) {
                    flkty.previous(true);
                  } else {
                    flkty.next(true);
                  }
                }
              }, { passive: true });
            }
          });
        });
      });
      observer.observe(media, { childList: true, subtree: true });
    });
  }
  const viewportObserver = new MutationObserver(() => {
    const flickityViewport = galleryEl.querySelector('.flickity-viewport');
    const flickitySlider = galleryEl.querySelector('.flickity-slider');
    if (flickityViewport && flickitySlider) {
      // watch button hide for slides after the videos
      hideMobileWatchButtonsAfterDeferredMedia();
      viewportObserver.disconnect();
      startObserving();
    }
  });
  viewportObserver.observe(galleryEl, { childList: true, subtree: true });
}
setupVideoSwipeControlWithoutInstance();

// carousel usp
console.log("carousel usp");
setTimeout(() => {
    const carouselUsp = document.querySelector('#carousel-usp');
    if (!carouselUsp) return;
    const carouselUspFl = Flickity.data(carouselUsp);
    if (!carouselUspFl) return;
    carouselUspFl.on('dragEnd', () => {
      carouselUspFl.playPlayer();
    });
    carouselUspFl.on('staticClick', () => {
      carouselUspFl.playPlayer();
    });

    // Flickity measures the container once at init. If the PDP column width
    // changes afterwards (late layout, no window resize event) the cells stay
    // sized/offset for the old width and the text looks off-centre. Re-measure
    // whenever the real width differs from Flickity's stored width.
    if ('ResizeObserver' in window) {
      new ResizeObserver(() => {
        if (Math.round(carouselUspFl.size.width) === carouselUsp.offsetWidth) return;
        // Flickity.resize() is a no-op mid-animation, so wait for it to settle.
        if (carouselUspFl.isAnimating || carouselUspFl.isDragging) {
          carouselUspFl.once('settle', () => carouselUspFl.resize());
        } else {
          carouselUspFl.resize();
        }
      }).observe(carouselUsp);
    }
}, 2000);

// slide out modal scroll js fix
console.log("slide out modal scroll js fix");
document.querySelectorAll('.product-modal__content-inner').forEach(container => {
  let lastTouchY = 0;
  container.addEventListener('touchstart', function (e) {
    lastTouchY = e.touches[0].clientY;
    const scrollTop = container.scrollTop;
    const scrollHeight = container.scrollHeight;
    const offsetHeight = container.offsetHeight;
    if (scrollTop + offsetHeight >= scrollHeight) {
      container.scrollTop -= 100;
      console.log('Nudged up from bottom');
    }
  });
});
